/* eslint-disable react/jsx-one-expression-per-line */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable react/prop-types */
import React from 'react';
import classNames from 'classnames';

// components
import { Grid, Message, Button } from '@design-system-coopeuch/web';
import CardVoucher from './CardVoucher';
import CardPasswordAndDigitize from './CardPasswordAndDigitize';
import CardNextSteps from './CardNextSteps';
import FlowControlButtons from '../../molecules/FlowControlButtons/FlowControlButtons';
import Modal from '../../organisms/Modal/Modal';
import Survey from '../../../containers/Survey/Survey';
// assets
import { StyledWrapperCards } from './styles';
import iconSuccess from '../../../assets/img/icon-person-success-female-desktop.svg';

const SummaryTemplate = (props) => {
  const {
    email,
    amountMonthlyFees,
    transactionDateTimeLong,
    detailData,
    isMobileDevice,
    monthlyFees,
    isOpenModalPaymentSuccess,
    closeModalPaymentSuccess,
    isOpenModalVoucherDetail,
    openModalVoucherDetail,
    closeModalVoucherDetail,
    isOpenModalUsabilityAndSatisfactionSurvey,
    closeModalUsabilityAndSatisfactionSurvey,
    onDownloadComponentPdf,
    onReturnMainPage,
    onCallSurvey,
    phone,
    password,
    confirmationPassword,
    inputCodeSMS,
    stateAuthSms,
    stateCreatingPassword,
    canValidateOtp,
    canCreatePassword,
    passwordVisibility,
    confirmationPasswordVisibility,
    messagesInputAuthSms,
    onInvokeAuthSms,
    onChangeEletronicSignature,
    onTimeOverToRespond,
    onChangePasswordVisibility,
    onValidateOtp,
    onCreatePassword,
    storeSelected,
    onChangeStoreSelected,
    isOpenCurrentModal,
    nameCurrentModal,
    onCloseCurrentModal,
    onOpenCurrentModal,
    onRedirectToPrivateSite,
  } = props;

  return (
    <>
      <StyledWrapperCards>
        <Message
          className="w-100"
          type="success"
          description={
            <p>
              <span className="font-weight-bold">¡Felicitaciones!</span> Ya eres Socio Coopeuch.
            </p>
          }
          closer={null}
        />
        <CardVoucher
          email={email}
          monthlyFees={monthlyFees}
          amountMonthlyFees={amountMonthlyFees}
          transactionDateTimeLong={transactionDateTimeLong}
          detailData={detailData}
          isOpenModalVoucherDetail={isOpenModalVoucherDetail}
          closeModalVoucherDetail={closeModalVoucherDetail}
          openModalVoucherDetail={openModalVoucherDetail}
          isMobileDevice={isMobileDevice}
          onDownloadComponentPdf={onDownloadComponentPdf}
          onCallSurvey={onCallSurvey}
        />
        <CardPasswordAndDigitize
          phone={phone}
          password={password}
          confirmationPassword={confirmationPassword}
          inputCodeSMS={inputCodeSMS}
          stateAuthSms={stateAuthSms}
          stateCreatingPassword={stateCreatingPassword}
          passwordVisibility={passwordVisibility}
          confirmationPasswordVisibility={confirmationPasswordVisibility}
          canValidateOtp={canValidateOtp}
          canCreatePassword={canCreatePassword}
          messagesInputAuthSms={messagesInputAuthSms}
          storeSelected={storeSelected}
          onInvokeAuthSms={onInvokeAuthSms}
          onChange={onChangeEletronicSignature}
          onTimeOverToRespond={onTimeOverToRespond}
          onValidateOtp={onValidateOtp}
          onCreatePassword={onCreatePassword}
          onChangeStoreSelected={onChangeStoreSelected}
          onChangePasswordVisibility={onChangePasswordVisibility}
          isOpenCurrentModal={isOpenCurrentModal}
          nameCurrentModal={nameCurrentModal}
          onCloseCurrentModal={onCloseCurrentModal}
          onOpenCurrentModal={onOpenCurrentModal}
          onRedirectToPrivateSite={onRedirectToPrivateSite}
        />
        <CardNextSteps
          email={email}
          isMobileDevice={isMobileDevice}
          onDownloadComponentPdf={onDownloadComponentPdf}
        />
        <FlowControlButtons
          step="end"
          onReturnMainPage={onReturnMainPage}
          onCallSurvey={onCallSurvey}
        />
      </StyledWrapperCards>
      <Modal
        isOpen={isOpenModalPaymentSuccess}
        closeModal={closeModalPaymentSuccess}
        closeClickOutside
        closeEscKey
        className={classNames('modal-payment-success')}
      >
        <Grid row className="d-flex flex-column justify-content-center align-items-center">
          <Grid
            col={12}
            md={8}
            className="p-5 d-flex flex-column justify-content-center align-items-center"
          >
            <img src={iconSuccess} alt="" width="140" className="mt-3" />
            <p className="text-center mt-3 mb-3 font-size-18 font-weight-500">¡Pago exitoso!</p>
            <article>
              <p className="text-center mb-1">
                {`Has pagado ${monthlyFees} cuotas por un total de ${amountMonthlyFees}.`}
              </p>
            </article>
          </Grid>
        </Grid>
        <Grid className="p-5 border-top border-neutral-alfa-15 d-flex justify-content-center align-items-center">
          <Button
            variant="default"
            color="primary"
            onClick={closeModalPaymentSuccess}
            className="text-center justify-content-center font-size-14"
          >
            Entendido, continuar
          </Button>
        </Grid>
      </Modal>
      <Modal
        isOpen={isOpenModalUsabilityAndSatisfactionSurvey}
        closeModal={closeModalUsabilityAndSatisfactionSurvey}
      >
        <Survey type="usabilityAndSatisfaction" />
      </Modal>
    </>
  );
};

export default SummaryTemplate;
